import { IWM } from "../config/urlConfig";

// Fetches every pickup whose driver has started navigation (a "live trip") for
// the current organization. Used to surface live-tracking notifications on the
// dashboard.
export const getLiveTrips = () => async (dispatch) => {
  dispatch({ type: "GETTING_LIVE_TRIPS" });
  try {
    const res = await IWM.get("/pickups/read/live-trips");
    dispatch({ type: "GOT_LIVE_TRIPS", payload: res.data });
  } catch (ex) {
    console.log(ex);
    dispatch({
      type: "CANNOT_GET_LIVE_TRIPS",
      payload: ex.response?.data,
    });
  }
};

export const DISMISSED_LIVE_TRIPS_KEY = "dismissedLiveTrips";

// Permanently hides a live-trip notification (the card's close button). The
// dismissed ids are persisted to localStorage so a closed card never reopens —
// not on the next poll, and not after a refresh. The trip stays reachable from
// the "Track Live" action in the pickups table.
export const dismissLiveTrip = (pickupId) => {
  try {
    const existing = JSON.parse(
      localStorage.getItem(DISMISSED_LIVE_TRIPS_KEY) || "[]"
    );
    if (!existing.includes(pickupId)) {
      localStorage.setItem(
        DISMISSED_LIVE_TRIPS_KEY,
        JSON.stringify([...existing, pickupId])
      );
    }
  } catch (e) {
    console.log(e);
  }

  return { type: "DISMISS_LIVE_TRIP", payload: pickupId };
};
